<script lang="ts">
	import FormWithLabel from "../../molecules/FormWithLabel.svelte";
	import type { RecruitmentService } from "../../services/recruitment.service";

	export let service: RecruitmentService
	export let klass = ''
	const model = service.store.model
	const models = service.store.facilityForms
</script>

<div class="{klass}">
	<FormWithLabel
		label="施設形態"
		input={service.handleFacilityForms}
		values={$model.facilityForms}
		value={$model.facilityForms[0]}
		inputType="select"
		options={$models}
	/>
</div>